<template>
  <div class="memo-page">
    <el-header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>备忘录管理</el-breadcrumb-item>
      </el-breadcrumb>

      <div style="position: absolute; right: 100px;top: 20px;font-size: 15px">
        <div style="display:flex;align-items:center;">
          <el-avatar size="large" style="margin: 5px;"
                     src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"></el-avatar>
          {{ username }}
          <el-button type="text" @click="out" style="margin: 5px;">退出登录</el-button>
        </div>
      </div>
    </el-header>

    <div v-if="classesError && classFeatureSupported" class="partner-retry">
      <span><i class="el-icon-warning-outline"></i>{{ classesError }}</span>
      <el-button type="text" @click="loadClasses">重试加载客户分类</el-button>
    </div>
    <div v-if="partnersError" class="partner-retry">
      <span><i class="el-icon-warning-outline"></i>{{ partnersError }}</span>
      <el-button type="text" @click="loadPartners">重试加载客户</el-button>
    </div>
    <el-form :inline="true" class="filter-form" @submit.native.prevent>
      <el-form-item v-if="classFeatureSupported" label="客户分类">
        <el-cascader
          v-model="query.classId"
          :options="classes"
          :props="classCascaderProps"
          filterable
          clearable
          placeholder="选择任意一级分类"
          @change="handleQueryClassChange"
        />
      </el-form-item>
      <el-form-item label="客户">
        <el-select
          v-model="query.partnerId"
          filterable
          clearable
          :filter-method="filterPartners"
          placeholder="搜索或选择客户"
          @visible-change="handlePartnerVisible"
          @clear="filterPartners('')"
          @change="handleQueryPartnerChange"
        >
          <el-option
            v-for="item in filteredPartners"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
            <span class="partner-option-name">{{ item.name }}</span>
            <el-tag
              v-if="item.source === 'LOCAL'"
              type="info"
              size="mini"
              class="local-source-tag"
            >本地
            </el-tag>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="日期范围">
        <el-date-picker
          v-model="query.dateRange"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          unlink-panels
          clearable
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" plain icon="el-icon-search" :loading="loading" @click="search">查询</el-button>
        <el-button icon="el-icon-refresh-left" :disabled="loading" @click="resetSearch">重置</el-button>
      </el-form-item>
        <el-form-item>
        <el-button
          v-if="classFeatureSupported"
          icon="el-icon-user"
          @click="openLocalDialog"
        >本地客户管理
        </el-button>
        <el-button type="primary" icon="el-icon-plus" @click="openCreate">新增备忘录</el-button>
      </el-form-item>

    </el-form>

    <div v-if="listError" class="error-strip" role="alert">
      <i class="el-icon-warning-outline"></i>
      <span>{{ listError }}</span>
      <el-button type="text" @click="loadList(false)">重新加载</el-button>
    </div>



      <el-table
        v-loading="loading"
        :data="tableData"
        border
        stripe
        row-key="id"
        class="memo-table"
        element-loading-text="正在加载备忘录..."
      >
        <el-table-column label="序号" width="62" align="center">
          <template slot-scope="scope">
            {{ (scope.$index + 1) + (currentPage - 1) * pageSize }}
          </template>
        </el-table-column>
        <el-table-column prop="memoTime" label="备忘时间" width="170"/>
        <el-table-column prop="partnerName" label="客户" min-width="150" show-overflow-tooltip/>
        <el-table-column label="备忘内容" min-width="260">
          <template slot-scope="scope">
            <div class="memo-content">{{ scope.row.content }}</div>
          </template>
        </el-table-column>
        <el-table-column label="图片" min-width="176">
          <template slot-scope="scope">
            <div v-if="scope.row.imageUrls.length" class="image-strip">
              <el-image
                v-for="(url, imageIndex) in scope.row.imageUrls"
                :key="url + '-' + imageIndex"
                :src="url"
                :preview-src-list="scope.row.imageUrls"
                fit="cover"
                lazy
                class="memo-thumb"
              />
            </div>
            <span v-else class="empty-value">无图片</span>
          </template>
        </el-table-column>
        <el-table-column prop="creatorAccount" label="创建账号" width="100" show-overflow-tooltip/>
        <el-table-column label="操作" fixed="right" width="120" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="medium" @click="openEdit(scope.row)">编辑</el-button>
            <el-button
              type="text"
              size="medium"
              class="delete-button"
              :loading="deletingId === scope.row.id"
              @click="deleteMemo(scope.row)"
            >删除
            </el-button>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="empty-ledger">
            <i class="el-icon-notebook-2"></i>
            <span>{{ listError ? '记录加载失败' : '当前条件下没有备忘录' }}</span>
          </div>
        </template>
      </el-table>

      <div class="pagination-wrap">
        <el-pagination
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>

    <el-dialog
      :title="dialogMode === 'create' ? '新增备忘录' : '编辑备忘录'"
      :visible.sync="dialogVisible"
      width="720px"
      top="5vh"
      custom-class="memo-dialog"
      :before-close="beforeDialogClose"
      @closed="resetDialog"
    >

      <el-form ref="memoForm" :model="form" :rules="rules" label-width="88px">
        <el-form-item v-if="classFeatureSupported" label="客户分类">
          <el-cascader
            v-model="formClassId"
            :options="classes"
            :props="classCascaderProps"
            filterable
            clearable
            placeholder="按分类缩小客户范围"
            class="full-control"
            @change="handleFormClassChange"
          />
        </el-form-item>
        <el-form-item label="客户" prop="partnerId">
          <el-select
            v-model="form.partnerId"
            filterable
            clearable
            :filter-method="filterFormPartners"
            placeholder="搜索或选择客户"
            class="full-control"
            @visible-change="handleFormPartnerVisible"
            @clear="filterFormPartners('')"
          >
            <el-option
              v-for="item in filteredFormPartners"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
              <span class="partner-option-name">{{ item.name }}</span>
              <el-tag
                v-if="item.source === 'LOCAL'"
                type="info"
                size="mini"
                class="local-source-tag"
              >本地
              </el-tag>
            </el-option>
          </el-select>
          <div v-if="formPartnersError" class="partner-retry form-partner-retry">
            <span><i class="el-icon-warning-outline"></i>{{ formPartnersError }}</span>
            <el-button type="text" @click="retryFormPartners">重试加载客户</el-button>
          </div>
        </el-form-item>
        <el-form-item label="备忘时间" prop="memoTime">
          <el-date-picker
            v-model="form.memoTime"
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择时间"
            class="full-control"
          />
        </el-form-item>
        <el-form-item label="备忘内容" prop="content">
          <el-input
            v-model="form.content"
            type="textarea"
            :rows="6"
            :maxlength="2000"
            show-word-limit
            resize="vertical"
            placeholder="填写客户跟进情况、约定事项或其他说明"
          />
        </el-form-item>
        <el-form-item label="图片">
          <el-upload
            action="/admin/memo/image"
            list-type="picture-card"
            accept="image/*"
            :file-list="fileList"
            :limit="9"
            :disabled="saving || uploading > 0"
            :http-request="uploadImage"
            :before-upload="beforeImageUpload"
            :on-success="handleUploadSuccess"
            :on-error="handleUploadError"
            :on-remove="handleImageRemove"
            :on-preview="handleImagePreview"
            :on-exceed="handleImageExceed"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button :disabled="saving || uploading > 0" @click="dialogVisible = false">取消</el-button>
        <el-button
          type="primary"
          :loading="saving"
          :disabled="uploading > 0"
          @click="submitForm"
        >{{ dialogMode === 'create' ? '保存备忘录' : '保存修改' }}
        </el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="本地客户管理"
      :visible.sync="localDialogVisible"
      width="820px"
      top="6vh"
      custom-class="local-partner-dialog"
    >
      <div class="local-toolbar">
        <el-input
          v-model="localQuery.keyword"
          clearable
          prefix-icon="el-icon-search"
          placeholder="搜索本地客户名称"
          @keyup.enter.native="searchLocalPartners"
          @clear="searchLocalPartners"
        />
        <el-button type="primary" plain @click="searchLocalPartners">查询</el-button>
        <el-button type="primary" icon="el-icon-plus" @click="openLocalCreate">新增本地客户</el-button>
      </div>

      <div v-if="localError" class="error-strip local-error" role="alert">
        <i class="el-icon-warning-outline"></i>
        <span>{{ localError }}</span>
        <el-button type="text" @click="loadLocalPartners">重试</el-button>
      </div>

      <el-table
        v-loading="localLoading"
        :data="localRows"
        border
        stripe
        row-key="id"
        class="local-table"
        element-loading-text="正在读取本地客户..."
      >
        <el-table-column prop="name" label="客户名称" min-width="220" show-overflow-tooltip/>
        <el-table-column label="当前分类" min-width="280" show-overflow-tooltip>
          <template slot-scope="scope">
            <span :class="{'missing-class': !scope.row.classExists}">
              {{ localClassText(scope.row) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="openLocalEdit(scope.row)">编辑</el-button>
            <el-button
              type="text"
              class="delete-button"
              :loading="localDeletingId === scope.row.id"
              @click="deleteLocalPartner(scope.row)"
            >删除
            </el-button>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="empty-ledger">
            <i class="el-icon-user"></i>
            <span>{{ localError ? '本地客户加载失败' : '暂无本地客户' }}</span>
          </div>
        </template>
      </el-table>

      <div class="pagination-wrap local-pagination">
        <el-pagination
          :current-page="localQuery.pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="localQuery.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="localTotal"
          @size-change="handleLocalSizeChange"
          @current-change="handleLocalPageChange"
        />
      </div>
    </el-dialog>

    <el-dialog
      :title="localFormMode === 'create' ? '新增本地客户' : '编辑本地客户'"
      :visible.sync="localFormVisible"
      width="520px"
      append-to-body
      :close-on-click-modal="false"
      :before-close="beforeLocalFormClose"
      :close-on-press-escape="!localSaving"
      :show-close="!localSaving"
      custom-class="local-partner-form-dialog"
      @closed="resetLocalForm"
    >
      <el-form
        ref="localPartnerForm"
        :model="localForm"
        :rules="localRules"
        label-width="88px"
      >
        <el-form-item label="客户名称" prop="name">
          <el-input
            v-model="localForm.name"
            :maxlength="255"
            show-word-limit
            clearable
            placeholder="填写本地客户名称"
          />
        </el-form-item>
        <el-form-item label="客户分类" prop="classId">
          <el-cascader
            v-model="localForm.classId"
            :options="classes"
            :props="classCascaderProps"
            filterable
            clearable
            placeholder="请选择最末级客户分类"
            class="full-control"
          />
          <div v-if="classesError" class="partner-retry form-partner-retry">
            <span><i class="el-icon-warning-outline"></i>{{ classesError }}</span>
            <el-button type="text" @click="loadClasses">重试加载客户分类</el-button>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button :disabled="localSaving" @click="localFormVisible = false">取消</el-button>
        <el-button type="primary" :loading="localSaving" @click="submitLocalPartner">
          {{ localFormMode === 'create' ? '新增客户' : '保存修改' }}
        </el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="图片预览"
      :visible.sync="previewVisible"
      width="64%"
      append-to-body
      custom-class="image-preview-dialog"
    >
      <img v-if="previewUrl" :src="previewUrl" alt="备忘录图片预览" class="preview-image">
    </el-dialog>
  </div>
</template>

<script>
function pad(value) {
  return String(value).padStart(2, '0')
}

function formatLocalMinute(date) {
  return date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate()) + ' ' +
    pad(date.getHours()) + ':' + pad(date.getMinutes()) + ':00'
}

function normalizeMinute(value) {
  const text = String(value || '').trim()
  const match = text.match(/^(\d{4}-\d{2}-\d{2} \d{2}:\d{2})(?::\d{2})?$/)
  return match ? match[1] + ':00' : text
}

function emptyForm() {
  return {
    id: null,
    partnerId: '',
    memoTime: formatLocalMinute(new Date()),
    content: ''
  }
}

function emptyLocalForm() {
  return {
    id: null,
    name: '',
    classId: ''
  }
}

function validateContent(rule, value, callback) {
  const content = String(value || '').trim()
  if (!content) {
    callback(new Error('请填写备忘录内容'))
    return
  }
  if (content.length > 2000) {
    callback(new Error('备忘录内容不能超过2000字'))
    return
  }
  callback()
}

function validateLocalName(rule, value, callback) {
  const name = String(value || '').trim()
  if (!name) {
    callback(new Error('请填写客户名称'))
    return
  }
  if (name.length > 255) {
    callback(new Error('客户名称不能超过255字'))
    return
  }
  callback()
}

export default {
  name: 'memo',
  data() {
    return {
      username: localStorage.getItem('name'),
      loading: false,
      tableData: [],
      classes: [],
      classesError: '',
      classFeatureSupported: true,
      classCascaderProps: {
        value: 'id',
        label: 'name',
        children: 'children',
        checkStrictly: true,
        emitPath: false
      },
      partners: [],
      filteredPartners: [],
      formPartners: [],
      filteredFormPartners: [],
      formPartnersError: '',
      formPartnersReady: false,
      formPartnerRequestId: 0,
      query: {
        partnerId: '',
        classId: '',
        dateRange: []
      },
      currentPage: 1,
      pageSize: 20,
      total: 0,
      listError: '',
      partnersError: '',
      dialogVisible: false,
      dialogMode: 'create',
      saving: false,
      uploading: 0,
      deletingId: null,
      form: emptyForm(),
      formClassId: '',
      formOriginalPartnerId: '',
      formOriginalPartnerName: '',
      fileList: [],
      previewVisible: false,
      previewUrl: '',
      localDialogVisible: false,
      localLoading: false,
      localRows: [],
      localTotal: 0,
      localError: '',
      localRequestId: 0,
      localQuery: {
        keyword: '',
        pageNum: 1,
        pageSize: 20
      },
      localFormVisible: false,
      localFormMode: 'create',
      localSaving: false,
      localDeletingId: null,
      localForm: emptyLocalForm(),
      rules: {
        partnerId: [{required: true, message: '请选择客户', trigger: 'change'}],
        memoTime: [{required: true, message: '请选择备忘时间', trigger: 'change'}],
        content: [{validator: validateContent, trigger: 'blur'}]
      },
      localRules: {
        name: [{validator: validateLocalName, trigger: 'blur'}],
        classId: [{required: true, message: '请选择客户分类', trigger: 'change'}]
      }
    }
  },
  mounted() {
    this.loadClasses()
    this.loadPartners()
    this.loadList(false)
  },
  methods: {
    unwrap(response, fallback) {
      const body = response && response.data
      if (!body || String(body.code) !== '200') {
        throw new Error((body && body.message) || fallback)
      }
      return body.data
    },
    errorMessage(error, fallback) {
      return error && error.message ? error.message : fallback
    },
    normalizeClassId(value) {
      const selected = Array.isArray(value) ? value[value.length - 1] : value
      return String(selected || '').trim()
    },
    loadClasses() {
      this.classesError = ''
      return this.$axios.get('/admin/memo/classes')
        .then(response => {
          const data = this.unwrap(response, '客户分类加载失败')
          this.classes = Array.isArray(data) ? data : []
          this.classFeatureSupported = true
          this.classesError = ''
        })
        .catch(error => {
          const message = this.errorMessage(error, '客户分类加载失败')
          this.classes = []
          this.query.classId = ''
          this.formClassId = ''
          if (message === '当前数据库版本不支持客户分类') {
            this.classFeatureSupported = false
            this.classesError = ''
            this.localDialogVisible = false
            this.localFormVisible = false
            return
          }
          this.classFeatureSupported = true
          this.classesError = message
          this.$message.error(message)
        })
    },
    partnerRequestParams(classId) {
      const params = {includeLocal: true}
      const normalizedClassId = this.normalizeClassId(classId)
      if (normalizedClassId) params.classId = normalizedClassId
      return params
    },
    loadPartners() {
      this.partnersError = ''
      return this.$axios.get('/admin/memo/partners', {
        params: this.partnerRequestParams('')
      })
        .then(response => {
          const data = this.unwrap(response, '客户列表加载失败')
          this.partners = Array.isArray(data) ? data : []
          this.filteredPartners = this.partners.slice()
          this.partnersError = ''
        })
        .catch(error => {
          const message = this.errorMessage(error, '客户列表加载失败')
          this.partnersError = message
          this.$message.error(message)
        })
    },
    loadFormPartners(classId, passiveRefresh) {
      const normalizedClassId = this.normalizeClassId(classId)
      this.formClassId = normalizedClassId
      this.formPartnersError = ''
      this.formPartnersReady = false
      const requestId = ++this.formPartnerRequestId
      return this.$axios.get('/admin/memo/partners', {
        params: this.partnerRequestParams(normalizedClassId)
      })
        .then(response => {
          if (requestId !== this.formPartnerRequestId) return
          const data = this.unwrap(response, '客户列表加载失败')
          let options = Array.isArray(data) ? data.slice() : []
          const selectedId = String(this.form.partnerId || '').trim()
          const selectedExists = options.some(item =>
            String(item.id) === selectedId)
          // 被动刷新可以保留编辑时的原客户快照；主动切换分类仍以当前选项为准。
          const keepsOriginalSnapshot = Boolean(passiveRefresh &&
            this.dialogMode === 'edit' && selectedId &&
            selectedId === this.formOriginalPartnerId)

          if (selectedId && !selectedExists) {
            if (keepsOriginalSnapshot) {
              const historicalOption = {
                id: this.formOriginalPartnerId,
                name: this.formOriginalPartnerName || this.formOriginalPartnerId,
                source: 'HISTORY',
                classId: null,
                historical: true
              }
              const historicalIndex = options.length > 0 &&
              String(options[0].id) === 'OTHER' ? 1 : 0
              options.splice(historicalIndex, 0, historicalOption)
            } else {
              this.form.partnerId = ''
            }
          }
          this.formPartners = options
          this.filteredFormPartners = options.slice()
          this.formPartnersReady = true
          this.formPartnersError = ''
        })
        .catch(error => {
          if (requestId !== this.formPartnerRequestId) return
          const message = this.errorMessage(error, '客户列表加载失败')
          this.formPartnersReady = false
          this.formPartnersError = message
          this.$message.error(message)
        })
    },
    retryFormPartners() {
      return this.loadFormPartners(
        this.formClassId, this.dialogMode === 'edit')
    },
    filterPartners(keyword) {
      const value = String(keyword || '').trim().toLowerCase()
      this.filteredPartners = value
        ? this.partners.filter(item => String(item.id) !== 'OTHER' &&
          String(item.name || '').toLowerCase().includes(value))
        : this.partners.slice()
    },
    filterFormPartners(keyword) {
      const value = String(keyword || '').trim().toLowerCase()
      this.filteredFormPartners = value
        ? this.formPartners.filter(item => String(item.id) !== 'OTHER' &&
          String(item.name || '').toLowerCase().includes(value))
        : this.formPartners.slice()
    },
    handlePartnerVisible(visible) {
      if (visible) {
        this.filteredPartners = this.partners.slice()
      }
    },
    handleFormPartnerVisible(visible) {
      if (visible) {
        this.filteredFormPartners = this.formPartners.slice()
      }
    },
    handleQueryPartnerChange(value) {
      this.query.partnerId = String(value || '').trim()
      if (this.query.partnerId) this.query.classId = ''
    },
    handleQueryClassChange(value) {
      this.query.classId = this.normalizeClassId(value)
      if (this.query.classId) this.query.partnerId = ''
    },
    handleFormClassChange(value) {
      this.formClassId = this.normalizeClassId(value)
      return this.loadFormPartners(this.formClassId, false)
    },
    openLocalDialog() {
      if (!this.classFeatureSupported) return
      this.localDialogVisible = true
      this.loadLocalPartners()
    },
    loadLocalPartners() {
      const params = {
        keyword: String(this.localQuery.keyword || '').trim(),
        pageNum: this.localQuery.pageNum,
        pageSize: this.localQuery.pageSize
      }
      const requestId = ++this.localRequestId
      this.localLoading = true
      this.localError = ''
      return this.$axios.get('/admin/memo/local-partners', {params: params})
        .then(response => {
          if (requestId !== this.localRequestId) return
          const data = this.unwrap(response, '本地客户加载失败') || {}
          this.localRows = Array.isArray(data.records) ? data.records : []
          this.localTotal = Number(data.total) || 0
          this.localError = ''
        })
        .catch(error => {
          if (requestId !== this.localRequestId) return
          const message = this.errorMessage(error, '本地客户加载失败')
          this.localError = message
          this.$message.error(message)
        })
        .then(() => {
          if (requestId === this.localRequestId) this.localLoading = false
        })
    },
    searchLocalPartners() {
      this.localQuery.pageNum = 1
      this.loadLocalPartners()
    },
    handleLocalSizeChange(value) {
      this.localQuery.pageSize = value
      this.localQuery.pageNum = 1
      this.loadLocalPartners()
    },
    handleLocalPageChange(value) {
      this.localQuery.pageNum = value
      this.loadLocalPartners()
    },
    localClassText(row) {
      if (!row || !row.classExists) {
        return '分类不存在（原 ' + String(row && row.classId || '') + '）'
      }
      return row.classPath || row.className || ''
    },
    findClassById(nodes, classId) {
      const list = Array.isArray(nodes) ? nodes : []
      for (const node of list) {
        if (String(node.id) === classId) return node
        const child = this.findClassById(node.children, classId)
        if (child) return child
      }
      return null
    },
    openLocalCreate() {
      this.localFormMode = 'create'
      this.localForm = emptyLocalForm()
      this.localFormVisible = true
      this.$nextTick(() => {
        if (this.$refs.localPartnerForm) {
          this.$refs.localPartnerForm.clearValidate()
        }
      })
    },
    openLocalEdit(row) {
      this.localFormMode = 'edit'
      this.localForm = {
        id: row.id,
        name: row.name,
        classId: row.classId
      }
      this.localFormVisible = true
      this.$nextTick(() => {
        if (this.$refs.localPartnerForm) {
          this.$refs.localPartnerForm.clearValidate()
        }
      })
    },
    resetLocalForm() {
      this.localFormMode = 'create'
      this.localForm = emptyLocalForm()
      if (this.$refs.localPartnerForm) {
        this.$refs.localPartnerForm.clearValidate()
      }
    },
    beforeLocalFormClose(done) {
      if (this.localSaving) {
        this.$message.warning('请等待本地客户保存完成')
        return
      }
      done()
    },
    submitLocalPartner() {
      if (this.localSaving) return
      this.$refs.localPartnerForm.validate(valid => {
        if (!valid) return
        const classId = this.normalizeClassId(this.localForm.classId)
        const selectedClass = this.findClassById(this.classes, classId)
        if (!selectedClass) {
          this.$message.error('客户分类不存在，请重新选择')
          return
        }
        if (!selectedClass.leaf) {
          this.$message.error('请选择最末级客户分类')
          return
        }

        const payload = {
          name: String(this.localForm.name || '').trim(),
          classId: classId
        }
        this.localSaving = true
        const editing = this.localFormMode === 'edit'
        const request = editing
          ? this.$axios.put(
            '/admin/memo/local-partners/' + this.localForm.id, payload)
          : this.$axios.post('/admin/memo/local-partners', payload)

        request.then(response => {
          this.unwrap(response,
            editing ? '本地客户修改失败' : '本地客户新增失败')
          this.$message.success(
            editing ? '修改成功' : '新增成功')
          this.localFormVisible = false
          this.loadLocalPartners()
          this.loadPartners()
          this.loadFormPartners(this.formClassId, true)
        }).catch(error => {
          this.$message.error(this.errorMessage(error,
            editing ? '本地客户修改失败' : '本地客户新增失败'))
        }).then(() => {
          this.localSaving = false
        })
      })
    },
    deleteLocalPartner(row) {
      if (this.localDeletingId !== null) return
      const name = row && row.name ? row.name : '该本地客户'
      return this.$confirm(
        '删除后无法恢复，确定删除“' + name + '”吗？',
        '删除本地客户',
        {
          confirmButtonText: '确定删除',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          this.localDeletingId = row.id
          return this.$axios.delete('/admin/memo/local-partners/' + row.id)
            .then(response => {
              this.unwrap(response, '本地客户删除失败')
              if (this.localRows.length === 1 && this.localQuery.pageNum > 1) {
                this.localQuery.pageNum -= 1
              }
              this.$message.success('删除成功')
              this.loadLocalPartners()
              if (this.$axios && typeof this.$axios.get === 'function') {
                this.loadPartners()
                this.loadFormPartners(this.formClassId, true)
              }
            })
        })
        .catch(error => {
          if (error === 'cancel' || error === 'close') return
          this.$message.error(this.errorMessage(error, '本地客户删除失败'))
        })
        .then(() => {
          this.localDeletingId = null
        })
    },
    dateRangeError() {
      const range = Array.isArray(this.query.dateRange)
        ? this.query.dateRange
        : []
      if (range.length === 0) return ''

      const startDate = String(range[0] || '').trim()
      const endDate = String(range[1] || '').trim()
      if (range.length !== 2 || !startDate || !endDate) {
        return '请选择完整的时间范围'
      }
      if (startDate > endDate) {
        return '开始日期不能晚于结束日期'
      }
      return ''
    },
    loadList(clearRows) {
      const rangeError = this.dateRangeError()
      if (rangeError) {
        this.tableData = []
        this.total = 0
        this.listError = ''
        this.loading = false
        this.$message.warning(rangeError)
        return
      }
      if (clearRows) {
        this.tableData = []
        this.total = 0
      }
      const params = {
        pageNum: this.currentPage,
        pageSize: this.pageSize
      }
      const partnerId = String(this.query.partnerId || '').trim()
      const classId = this.normalizeClassId(this.query.classId)
      const range = Array.isArray(this.query.dateRange)
        ? this.query.dateRange
        : []
      const startDate = String(range[0] || '').trim()
      const endDate = String(range[1] || '').trim()
      if (classId) {
        params.classId = classId
      } else if (partnerId) {
        params.partnerId = partnerId
      }
      if (startDate && endDate) {
        params.startDate = startDate
        params.endDate = endDate
      }

      this.loading = true
      this.listError = ''
      this.$axios.get('/admin/memo', {params: params})
        .then(response => {
          const data = this.unwrap(response, '备忘录加载失败') || {}
          const records = Array.isArray(data.records) ? data.records : []
          this.tableData = records.map(row => {
            const item = Object.assign({}, row)
            item.images = Array.isArray(row.images) ? row.images.slice() : []
            item.imageUrls = item.images.map(this.imageUrl)
            return item
          })
          this.total = Number(data.total) || 0
        })
        .catch(error => {
          this.listError = this.errorMessage(error, '备忘录加载失败')
          if (classId) {
            this.tableData = []
            this.total = 0
          }
        })
        .then(() => {
          this.loading = false
        })
    },
    imageUrl(relativePath) {
      const cleanPath = String(relativePath || '').trim().replace(/^\/+/, '')
      return cleanPath ? '/image/' + cleanPath : ''
    },
    search() {
      this.currentPage = 1
      this.loadList(true)
    },
    resetSearch() {
      this.query.partnerId = ''
      this.query.classId = ''
      this.query.dateRange = []
      this.filteredPartners = this.partners.slice()
      this.currentPage = 1
      this.loadList(true)
    },
    handleSizeChange(value) {
      this.pageSize = value
      this.currentPage = 1
      this.loadList(true)
    },
    handleCurrentChange(value) {
      this.currentPage = value
      this.loadList(true)
    },
    openCreate() {
      this.dialogMode = 'create'
      this.form = emptyForm()
      this.formClassId = ''
      this.formOriginalPartnerId = ''
      this.formOriginalPartnerName = ''
      this.formPartnersError = ''
      this.formPartnersReady = false
      this.fileList = []
      this.formPartners = []
      this.filteredFormPartners = []
      this.dialogVisible = true
      this.loadFormPartners('', false)
      this.$nextTick(() => {
        if (this.$refs.memoForm) this.$refs.memoForm.clearValidate()
      })
    },
    openEdit(row) {
      this.dialogMode = 'edit'
      this.formClassId = ''
      this.formOriginalPartnerId = String(row.partnerId || '').trim()
      this.formOriginalPartnerName = String(
        row.partnerName || this.formOriginalPartnerId).trim()
      this.form = {
        id: row.id,
        partnerId: this.formOriginalPartnerId,
        memoTime: normalizeMinute(row.memoTime),
        content: row.content || ''
      }
      this.fileList = (row.images || []).map((serverPath, index) => ({
        uid: 'memo-' + row.id + '-' + index,
        name: String(serverPath).split('/').pop(),
        status: 'success',
        serverPath: serverPath,
        url: this.imageUrl(serverPath)
      }))
      this.formPartnersError = ''
      this.formPartnersReady = false
      this.formPartners = []
      this.filteredFormPartners = []
      this.dialogVisible = true
      this.loadFormPartners('', true)
      this.$nextTick(() => {
        if (this.$refs.memoForm) this.$refs.memoForm.clearValidate()
      })
    },
    beforeDialogClose(done) {
      if (this.uploading > 0) {
        this.$message.warning('请等待图片上传完成')
        return
      }
      if (this.saving) {
        this.$message.warning('请等待备忘录保存完成')
        return
      }
      done()
    },
    resetDialog() {
      if (this.uploading > 0) return
      this.dialogMode = 'create'
      this.saving = false
      this.form = emptyForm()
      this.formClassId = ''
      this.formOriginalPartnerId = ''
      this.formOriginalPartnerName = ''
      this.formPartnersError = ''
      this.formPartnersReady = false
      this.formPartners = []
      this.filteredFormPartners = []
      this.fileList = []
      this.previewUrl = ''
      if (this.$refs.memoForm) this.$refs.memoForm.clearValidate()
    },
    beforeImageUpload(file) {
      const isImage = Boolean(file && file.type && file.type.indexOf('image/') === 0)
      const isWithinLimit = Boolean(file && file.size <= 10 * 1024 * 1024)
      if (!isImage) {
        this.$message.error('只能上传图片文件')
      } else if (!isWithinLimit) {
        this.$message.error('单张图片不能超过10MiB')
      }
      return isImage && isWithinLimit
    },
    uploadImage(request) {
      const formData = new FormData()
      formData.append('file', request.file)
      this.uploading += 1
      const finishUpload = () => {
        this.uploading = Math.max(0, this.uploading - 1)
      }
      this.$axios.post('/admin/memo/image', formData)
        .then(response => {
          const path = this.unwrap(response, '图片上传失败')
          if (!path) throw new Error('图片上传失败')
          request.onSuccess({path: path})
        })
        .catch(error => {
          try {
            request.onError(error)
          } finally {
            this.$message.error(this.errorMessage(error, '图片上传失败'))
          }
        })
        .then(finishUpload, finishUpload)
    },
    handleUploadSuccess(response, file, fileList) {
      file.serverPath = response.path
      this.fileList = fileList.slice()
    },
    handleUploadError(error, file, fileList) {
      this.fileList = fileList.slice()
    },
    handleImageRemove(file, fileList) {
      this.fileList = fileList.slice()
    },
    handleImagePreview(file) {
      this.previewUrl = file.url || this.imageUrl(file.serverPath)
      this.previewVisible = true
    },
    handleImageExceed() {
      this.$message.warning('最多上传9张图片')
    },
    canSubmitFormPartner() {
      const selectedId = String(this.form.partnerId || '').trim()
      const keepsOriginalSnapshot = this.dialogMode === 'edit' &&
        selectedId && selectedId === this.formOriginalPartnerId
      if (keepsOriginalSnapshot) return true
      if (!this.formPartnersReady) return false
      return this.formPartners.some(item => String(item.id) === selectedId)
    },
    submitForm() {
      if (this.uploading > 0) {
        this.$message.warning('请等待图片上传完成')
        return
      }
      this.$refs.memoForm.validate(valid => {
        if (!valid) return
        if (!this.canSubmitFormPartner()) {
          this.$message.error('客户选项不可用，请重新加载后选择')
          return
        }
        const images = this.fileList.map(file => file.serverPath).filter(Boolean)
        if (images.length !== this.fileList.length) {
          this.$message.error('存在未上传成功的图片，请移除后重试')
          return
        }
        if (images.length > 9) {
          this.$message.error('最多上传9张图片')
          return
        }
        const payload = {
          partnerId: this.form.partnerId,
          memoTime: normalizeMinute(this.form.memoTime),
          content: String(this.form.content || '').trim(),
          images: images
        }
        this.saving = true
        const request = this.dialogMode === 'edit'
          ? this.$axios.put('/admin/memo/' + this.form.id, payload)
          : this.$axios.post('/admin/memo', payload)

        request.then(response => {
          this.unwrap(response, this.dialogMode === 'edit' ? '备忘录修改失败' : '备忘录新增失败')
          this.$message.success(this.dialogMode === 'edit' ? '修改成功' : '新增成功')
          this.dialogVisible = false
          this.loadList(false)
        }).catch(error => {
          this.$message.error(this.errorMessage(error, this.dialogMode === 'edit' ? '备忘录修改失败' : '备忘录新增失败'))
        }).then(() => {
          this.saving = false
        })
      })
    },
    deleteMemo(row) {
      const label = (row.partnerName || '该客户') + ' · ' + (row.memoTime || '')
      this.$confirm('删除后无法恢复，确定删除“' + label + '”的备忘录吗？', '删除备忘录', {
        confirmButtonText: '确定删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deletingId = row.id
        this.$axios.delete('/admin/memo/' + row.id)
          .then(response => {
            this.unwrap(response, '备忘录删除失败')
            if (this.tableData.length === 1 && this.currentPage > 1) {
              this.currentPage -= 1
            }
            this.$message.success('删除成功')
            this.loadList(false)
          })
          .catch(error => {
            this.$message.error(this.errorMessage(error, '备忘录删除失败'))
          })
          .then(() => {
            this.deletingId = null
          })
      }).catch(() => {
      })
    },
    out() {
      this.$router.push({name: 'login'})
    }
  }
}
</script>

<style scoped>
.memo-page {
  --paper: #f5f1e8;
  --paper-card: #fffdf8;
  --ink: #26322a;
  --muted: #7c806f;
  --moss: #3f6b55;
  --rule: #d9d3c4;
  width: 100%;
  min-width: 0;
  min-height: 100vh;
  box-sizing: border-box;
  padding: 24px 28px 36px;
  color: var(--ink);
  background-size: 100% 32px;
  font-family: "Microsoft YaHei", "PingFang SC", sans-serif;
}

.page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 20px;
  padding: 4px 2px 0;
}

.title-block {
  margin-top: 18px;
}

.ledger-code {
  display: inline-block;
  margin-bottom: 7px;
  color: var(--moss);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 2px;
}

.title-block h1 {
  margin: 0;
  font-family: "Noto Serif SC", "Songti SC", SimSun, serif;
  font-size: 30px;
  font-weight: 700;
  letter-spacing: 2px;
}

.title-block p {
  margin: 8px 0 0;
  color: var(--muted);
  font-size: 13px;
}

.account-block {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 3px;
  padding: 7px 12px;
  border: 1px solid var(--rule);
  border-radius: 20px;
  background: rgba(255, 253, 248, .78);
  font-size: 13px;
}

.account-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #5b8d69;
  box-shadow: 0 0 0 3px rgba(91, 141, 105, .14);
}

.filter-card,
.table-card {
  border: 1px solid var(--rule);
  border-radius: 6px;
  background: var(--paper-card);
  box-shadow: 0 8px 24px rgba(62, 54, 39, .055);
}

.filter-card {
  margin-bottom: 16px;
  padding: 18px 20px 4px;
}

.section-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
}

.section-heading > div {
  display: flex;
  align-items: baseline;
  gap: 10px;
}

.section-index {
  color: #a66042;
  font-family: Georgia, serif;
  font-size: 12px;
  font-weight: 700;
}

.section-heading strong {
  font-size: 16px;
  letter-spacing: 1px;
}

.section-note {
  color: var(--muted);
  font-size: 12px;
}

.filter-form {
  margin-top: 10px;
  flex-wrap: wrap;
  align-items: center;
}

.filter-form .el-select,
.filter-form .el-date-editor {
  width: 230px;
}

.partner-retry {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: -4px 0 12px;
  padding: 7px 11px;
  border: 1px solid #ead4b8;
  border-radius: 4px;
  color: #8a6237;
  background: #fff9ef;
  font-size: 12px;
}

.partner-retry i {
  margin-right: 6px;
}

.form-partner-retry {
  margin: 8px 0 0;
}

.error-strip {
  display: flex;
  align-items: center;
  gap: 9px;
  margin-bottom: 16px;
  padding: 10px 14px;
  border: 1px solid #e8c9bd;
  border-radius: 4px;
  color: #9a4f37;
  background: #fff7f2;
  font-size: 13px;
}

.error-strip .el-button {
  margin-left: auto;
}

.table-card {
  overflow: hidden;
}

.table-heading {
  margin: 0;
  padding: 16px 20px;
  border-bottom: 1px solid var(--rule);
}

.memo-table {
  width: 100%;
}

.memo-content {
  max-height: 88px;
  overflow: auto;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  line-height: 1.65;
}

.image-strip {
  display: flex;
  max-width: 244px;
  gap: 6px;
  overflow-x: auto;
  padding-bottom: 3px;
}

.memo-thumb {
  flex: 0 0 48px;
  width: 48px;
  height: 48px;
  border: 1px solid #e3ded2;
  border-radius: 3px;
  background: #f0ece3;
}

.empty-value {
  color: #aaa899;
  font-size: 12px;
}

.delete-button {
  color: #b14f3b;
}

.empty-ledger {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 28px 0;
  color: #aaa899;
}

.empty-ledger i {
  font-size: 28px;
}

.pagination-wrap {
  padding: 18px 20px;
  border-top: 1px solid var(--rule);
  text-align: right;
}

.dialog-caption {
  margin: -4px 0 20px 88px;
  padding-left: 12px;
  border-left: 3px solid var(--moss);
}

.dialog-caption span {
  color: var(--moss);
  font-family: Georgia, serif;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1.5px;
}

.dialog-caption p {
  margin: 4px 0 0;
  color: var(--muted);
  font-size: 12px;
}

.full-control {
  width: 100%;
}

.upload-hint {
  margin-top: 8px;
  color: var(--muted);
  font-size: 12px;
  line-height: 1.6;
}

.upload-hint span {
  display: block;
  color: var(--moss);
}

.preview-image {
  display: block;
  max-width: 100%;
  max-height: 72vh;
  margin: 0 auto;
  object-fit: contain;
}

@media (max-width: 900px) {
  .memo-page {
    padding: 18px 14px 28px;
  }

  .page-header,
  .section-heading {
    align-items: flex-start;
    flex-direction: column;
  }

  .account-block {
    align-self: flex-end;
  }

  .section-heading > div {
    flex-wrap: wrap;
  }

  .filter-form .el-select,
  .filter-form .el-date-editor {
    width: 200px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/memoView.vue